import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { resetIdSchema } from '../schemas/resetIdSchema';
import { useNavigate } from 'react-router-dom';
import { resetIdPhone } from '../api/auth';
import LabeledTextField from '../components/LabeledTextField';
import UserPageLayout from '../components/UserPageLayout';
import { Box, Button, Alert, Stack } from '@mui/material';

const ResetIdPhonePage = () => {
  const [phone_number, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError: setFormError,
  } = useForm({
    resolver: zodResolver(resetIdSchema),
    defaultValues: {
      email: '',
      confirmEmail: '',
    },
  });

  useEffect(() => {
    const savedPhone = localStorage.getItem('resetPhone');
    if (!savedPhone) {
      navigate('/forgot-id');
    } else {
      setPhone(savedPhone);
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    setFormError('root', { message: '' });
    setMessage('');

    try {
      const res = await resetIdPhone(
        phone_number,
        data.email,
        data.confirmEmail
      );

      if (res.message) {
        setMessage(res.message);
        localStorage.removeItem('resetPhone');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setFormError('root', {
          type: 'manual',
          message: 'ID再設定に失敗しました',
        });
      }
    } catch (e) {
      setFormError('root', {
        type: 'manual',
        message: '通信エラーが発生しました',
      });
    }
  };

  return (
    <UserPageLayout title="メールアドレス再設定" maxWidth="sm">
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          maxWidth: 'none',
          boxShadow: 'none',
          minHeight: 'fit-content',
          padding: 0,
          mt: '15dvh',
          alignItems: 'flex-start',
        }}
      >
        <LabeledTextField
          label="新しいメールアドレス"
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          autoFocus
          placeholder="新しいメールアドレスを入力してください"
          register={register}
          error={errors.email}
        />

        <LabeledTextField
          label="メールアドレス確認"
          id="confirmEmail"
          name="confirmEmail"
          type="email"
          autoComplete="email"
          placeholder="メールアドレスを再入力してください"
          register={register}
          error={errors.confirmEmail}
        />

        {errors.root && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errors.root.message}
          </Alert>
        )}

        {message && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {message}
          </Alert>
        )}

        <Stack direction="column" spacing={2} sx={{ mt: 3, width: '100%' }}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ borderRadius: 5 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? '処理中...' : 'IDを再設定'}
          </Button>
        </Stack>
      </Box>
    </UserPageLayout>
  );
};

export default ResetIdPhonePage;
